/** Download Highcharts SVG as PNG (depth chart). */
export function downloadSvgAsPng(svgString, filename) {
  return new Promise((resolve, reject) => {
    const svg = svgString.replace(/xmlns="[^"]*"/, 'xmlns="http://www.w3.org/2000/svg"');
    const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width || 1200;
      canvas.height = img.height || 600;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#0B1018";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob((pngBlob) => {
        URL.revokeObjectURL(url);
        if (!pngBlob) {
          reject(new Error("PNG export failed"));
          return;
        }
        triggerDownload(pngBlob, filename);
        resolve();
      }, "image/png");
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("SVG render failed"));
    };
    img.src = url;
  });
}

/** Branded OHLC summary card when TradingView iframe cannot be captured. */
export function downloadOhlcSummaryPng({
  pair,
  interval,
  o,
  h,
  l,
  c,
  changePct,
  quote,
  fmtPrice,
  fmtPct,
}, filename) {
  const canvas = document.createElement("canvas");
  canvas.width = 960;
  canvas.height = 540;
  const ctx = canvas.getContext("2d");
  const up = Number(changePct) >= 0;

  ctx.fillStyle = "#0B1018";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = "#131A24";
  ctx.fillRect(0, 0, canvas.width, 56);
  ctx.fillStyle = "#3B82F6";
  ctx.fillRect(0, 55, canvas.width, 2);

  ctx.fillStyle = "#E5E7EB";
  ctx.font = "bold 22px Inter, system-ui, sans-serif";
  ctx.fillText(`${pair} · ${interval}`, 24, 36);

  ctx.fillStyle = "#64748B";
  ctx.font = "13px Inter, system-ui, sans-serif";
  ctx.fillText("CoinMBX Trade", canvas.width - 140, 36);

  const rows = [
    ["Open", fmtPrice(o, quote)],
    ["High", fmtPrice(h, quote)],
    ["Low", fmtPrice(l, quote)],
    ["Close", fmtPrice(c, quote)],
    ["24h Change", fmtPct(changePct)],
  ];

  ctx.font = "16px ui-monospace, monospace";
  let y = 100;
  rows.forEach(([label, value]) => {
    ctx.fillStyle = "#94A3B8";
    ctx.fillText(label, 48, y);
    ctx.fillStyle = label === "24h Change" ? (up ? "#22C55E" : "#EF4444") : "#E5E7EB";
    ctx.fillText(String(value), 220, y);
    y += 44;
  });

  ctx.fillStyle = "#64748B";
  ctx.font = "12px Inter, system-ui, sans-serif";
  ctx.fillText("For full candlestick chart image, use Save in the TradingView chart toolbar.", 48, 480);

  canvas.toBlob((blob) => {
    if (blob) triggerDownload(blob, filename);
  }, "image/png");
}

function triggerDownload(blob, filename) {
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
